import { render, staticRenderFns } from "./UpdatePaymentMethod.vue?vue&type=template&id=1e975e86&"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports